import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAnalyticsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'customer-service-helpcenter-analytics',
	path: '/jira/helpcenter/analytics',
};
